<template>
  <div>
    <q-form
      ref="waybillDetail"
      class="waybill-form"
      :model="waybill"
      :rules="rules"
      label-width="200px"
    >
      <q-form-item
        v-if="isSuccess"
        label="-"
        prop=""
      >
        <h3>{{ resultMessage }}</h3>
      </q-form-item>
      
      <q-form-item
        label="سال"
        prop="year"
      >
        <q-input-number
          v-model="waybill.year"
        />
      </q-form-item>

      <q-form-item
        label="ماه"
        prop="month"
      >
        <q-input-number
          v-model="waybill.month"
        />
      </q-form-item>

      <q-form-item
        label="نتفکش"
        prop="truck"
      >
        <q-model-selector
          v-model="waybill.truck"
          plugin="gama"
          delegate="getTrucks"
          display-field="title"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>

      <q-form-item
        label="تاریخ بارنامه"
        prop="date"
      >
        <persian-date-picker
          ref="date"
          v-model="waybillDate"
          :editable="true"
        />
      </q-form-item>

      <q-form-item
        label="شماره بارنامه"
        prop="number"
      >
        <q-input
          v-model="waybill.number"
          @blur="inspectNumber()"
        />
      </q-form-item>

      <q-form-item
        label="مسیر"
        prop="route"
      >
        <q-model-selector
          v-model="waybill.route"
          plugin="gama"
          delegate="getRoutes"
          display-field="title"
          value-field="id"
          placeholder="..."
          style="width: 100%"
        />
      </q-form-item>

      <q-form-item
        label="وزن"
        prop="weight"
      >
        <q-input-number
          v-model="waybill.weight"
        />
      </q-form-item>
      <q-form-item
        label="حجم"
        prop="volume"
      >
        <q-input-number
          v-model="waybill.volume"
          @blur="calculatePayment"
        />
      </q-form-item>
      <q-form-item label="">
        <q-label v-model="baseCalculate" />
      </q-form-item>

      <q-form-item
        label="کرایه"
        prop="truckPayment"
      >
        <q-money
          v-model="waybill.truckPayment"
        />
      </q-form-item>

      <q-form-item>
        <q-button
          class="persist-button"
          type="primary"
          @click="persist()"
        >
          <span>اضافه کن</span>
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>

  export default {
    name: "QGamaWaybillDetail",

    props: {
      formStructure: {required: true, type: Object}
    },
    data() {
      return {
        isSuccess: false,
        resultMessage: '--',
        baseCalculate: '',
        waybillDeliveryDateToAgency: '',
        waybillDate: '',
        waybill: {
          truck: undefined,
          date: undefined,
          number: '',
          year: 0,
          month: 0,


          route: undefined,

          temperature: 0,
          weight: 0,
          volume: 0,
          refineryPayment: 0,
          truckPayment: 0
        },

        rules: {
          year: [
            {required: true, message: 'حتما سال بازنامه را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1395, max: 1420, message: 'سال بین 1395 و 1420 وارد کنید', trigger: 'blur'}
          ],
          month: [
            {required: true, message: 'ماه مربوط به بارنامه را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1, max: 12, message: 'ماه باید بین 1 تا 12 باشد', trigger: 'blur'}
          ],
          truck: [
            {required: true, message: 'نفتکش را انتخاب کنید', trigger: 'blur'}
          ],
          date: [
            {required: true, message: 'تاریخ بارنامه را وارد کنید', trigger: 'blur'}
          ],
          number: [
            {required: true, message: 'شماره بارنامه را وارد کنید', trigger: 'blur'},
            // {type: 'number', message: 'بارنامه فقط شماره باشد', trigger: 'blur'}
          ],
          route: [
            {required: true, message: 'مسیر مربوط به بارنامه را انتخاب کنید', trigger: 'blur'}
          ],
          weight: [
            {required: true, message: 'وزن را وارد کنید', trigger: 'blur'},
            {type: 'number', min: 1, max: 50000, message: 'بین 1 تا 50000 باشد', trigger: 'blur'}
          ],
          volume: [
            {required: true, message: 'حجم را وارد کنید', trigger: 'blur'},
            {type: 'number', min: 1, max: 50000, message: 'بین 1 تا 50000 لیتر باشد', trigger: 'blur'}
          ],
        }
      };
    },
    computed: {},
    watch: {},
    mounted() {
    },
    methods: {
      inspectNumber() {
        if(this.waybill.number && this.waybill.number !== '') {
          this.$delegate('gama', 'isWaybillExist', {
            number: this.waybill.number
          }).then((res) => {
            if (res.result.isExist) {
              this.$notify({
                title: 'اطلاعات تکراری',
                message: 'شماره بارنامه تکراری است.',
                type: 'error'
              });
              this.waybill.number = '';
              this.$refs.number.focus();
            }
          }).catch(() => {
          });
        }
      },
      calculatePayment() {
        this.$delegate('gama', 'calculateWaybillRent', {
          route: this.waybill.route,
          date: this.waybillDate,
          weight: this.waybill.weight,
          volume: this.waybill.volume
        }).then((res) => {
          this.waybill.truckPayment = res.result.truckPayment;
          this.waybill.refineryPayment = res.result.refineryPayment;
          if (res.result.baseOnVolume) {
            this.baseCalculate = 'محاسبه بر اساس حجم';
          } else {
            this.baseCalculate = 'محاسبه بر اساس وزن';
          }
        }).catch(() => {
        });
      },
      persist() {
        this.waybill.date = this.waybillDate;
        this.$refs['waybillDetail'].validate((valid) => {
          if (valid) {
            this.$delegate('gama', 'addWaybill', {
              waybill: this.waybill
            }).then((response) => {
              this.$notify({
                title: this.$qt('model.successPersistTitle'),
                message: response.message,
                type: 'success'
              });
              this.isSuccess = true;
              this.resultMessage = response.result.savedModel.number;
              this.waybill.date = undefined;
              this.waybillDate = '';
              this.waybill.number = '';
              this.waybill.route = undefined;
              this.waybill.temperature = 0;
              this.waybill.weight = 0;
              this.waybill.volume = 0;
              this.waybill.refineryPayment = 0;
              this.waybill.truckPayment = 0;
              this.waybill.baseCalculate = '';
              this.$refs.date.focus();
            }).catch(() => {
            });
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'warning'
            });
            return false;
          }
        });
      }
    },
  };

</script>

<style scoped>
    .waybill-form {
        padding: 10px;
    }
    .persist-button:hover, .persist-button:focus {
        background-color: red;
    }
</style>
